import FrequentlyUsedField from "@/enum/FrequentlyUsedField";

export const defaultFrequentlyUsedFields = [
    FrequentlyUsedField.PRINT_STATUS,
    FrequentlyUsedField.LOGISTICS_INFO_STATUS,
    FrequentlyUsedField.LOGISTICS_STAGNANT_HOURS,
    FrequentlyUsedField.QUICK_CRITERION,
    FrequentlyUsedField.BUYER_USERNAME,
    FrequentlyUsedField.ORDER_ORIGINAL_ID,
    FrequentlyUsedField.UNDELIVERABLE_AREA,
    FrequentlyUsedField.SHIPPING_ADDRESS,
    FrequentlyUsedField.SELLER_FLAG,
    FrequentlyUsedField.WAYBILL_NO,
    FrequentlyUsedField.CONSIGNEE_NAME,
    FrequentlyUsedField.CONSIGNEE_PHONE,
    FrequentlyUsedField.ORDER_ITEM_TITLE,
    FrequentlyUsedField.SKU_PROPERTIES,
];

export const allFrequentlyUsedFields = Object.entries(FrequentlyUsedField).map(([, v]) => v);
